import { createFileRoute } from '@tanstack/react-router';
import { SecretaryAreaFull } from '@/features/secretary/SecretaryAreaFull';

export const Route = createFileRoute('/_app/secretary/area')({
  component: SecretaryAreaFull,
});
